// Accessibility enhancements for keyboard navigation
document.addEventListener('DOMContentLoaded', function() {
  function enhanceNavigation() {
    function hasDropdown(element) {
      const nextSibling = element.nextElementSibling;
      if (nextSibling && 
          (nextSibling.classList.contains('dropdown-content') || 
           nextSibling.querySelector('.dropdown-content') ||
           nextSibling.hasAttribute('x-show'))) {
        return true;
      }

      if (element.hasAttribute('@click') || 
          element.hasAttribute('x-on:click') || 
          element.hasAttribute('x-data') ||
          element.getAttribute('role') === 'tab') {
        return true;
      }
      
      if (element.textContent.trim().toLowerCase() === 'shop') {
        return true;
      }
      
      return false;
    }

    function getAlpineStoreData() {
      if (window.Alpine) {
        const storeNames = ['header', 'navigation', 'nav', 'menu'];
        for (const name of storeNames) {
          const store = window.Alpine.store(name);
          if (store) {
            return store;
          }
        }
      }
      return null;
    }

    function triggerShopMegaMenu(shopItem) {
      const store = getAlpineStoreData();
      if (store && store.mobileMenu !== undefined) {
        store.mobileMenu = false;
      }
      
      if (window.Alpine) {
        if (store) {
          if (store.activeTab !== undefined) {
            store.activeTab = 'shop';
            return true;
          } else if (store.currentTab !== undefined) {
            store.currentTab = 'shop';
            return true;
          } else if (store.active !== undefined) {
            store.active = 'shop';
            return true;
          }
        }
        
        const alpineElements = document.querySelectorAll('[x-data]');
        for (const element of alpineElements) {
          if (window.Alpine && window.Alpine.raw) {
            const data = window.Alpine.raw(element);
            if (data && (data.activeTab !== undefined || data.active !== undefined || data.currentTab !== undefined)) {
              if (data.activeTab !== undefined) data.activeTab = 'shop';
              if (data.active !== undefined) data.active = 'shop';
              if (data.currentTab !== undefined) data.currentTab = 'shop';
              return true;
            }
          }
        }
      }
      
      const megaMenus = [
        '.megamenu-desktop',
        '.mega-menu',
        '#header-megamenu-collections .megamenu-desktop',
        '[x-show*="shop"][class*="desktop"]',
        '[x-show*="activeTab"][class*="desktop"]'
      ];
      
      for (const selector of megaMenus) {
        const megaMenu = document.querySelector(selector);
        if (megaMenu) {
          megaMenu.style.display = 'block';
          megaMenu.classList.add('active', 'open');
          megaMenu.removeAttribute('hidden');
          if (megaMenu.hasAttribute('x-show')) {
            megaMenu.setAttribute('x-show', 'true');
          }
          return true;
        }
      }
      
      if (shopItem.hasAttribute('@click') || shopItem.hasAttribute('x-on:click')) {
        shopItem.click();
        return true;
      }
      
      const shopSection = document.querySelector('#header-megamenu-collections, .header-megamenu-collections');
      if (shopSection) {
        const shopTabs = shopSection.querySelectorAll('[data-item-name*="shop"], [class*="level-1-link"]:contains("Shop")');
        
        if (shopTabs.length > 0) {
          shopTabs[0].click();
          return true;
        }
        
        const hiddenMenus = shopSection.querySelectorAll('.megamenu-desktop[style*="display: none"], [class*="mega-menu"][style*="display: none"]');
        hiddenMenus.forEach(menu => {
          menu.style.display = 'block';
          menu.classList.add('active', 'open');
        });
        
        return hiddenMenus.length > 0;
      }
      
      return false;
    }

    const processMenuItems = (items) => {
      items.forEach((item, index) => {
        if (item.hasAttribute('data-a11y-enhanced')) return;
        
        item.setAttribute('data-a11y-enhanced', 'true');
        
        const isDropdownTrigger = hasDropdown(item);
        const itemText = item.textContent.trim().toLowerCase();
        
        if (isDropdownTrigger) {
          item.setAttribute('aria-expanded', 'false');
          item.setAttribute('aria-haspopup', 'true');
          
          if (item.tagName === 'BUTTON') {
            const submenu = item.nextElementSibling;
            if (submenu) {
              const submenuId = `submenu-${index}-${Math.floor(Math.random() * 1000)}`;
              submenu.id = submenuId;
              item.setAttribute('aria-controls', submenuId);
              submenu.setAttribute('role', 'menu');
              
              const submenuLinks = submenu.querySelectorAll('a');
              submenuLinks.forEach(link => {
                link.setAttribute('role', 'menuitem');
                link.setAttribute('tabindex', '0');
              });
            }
          }
          
          item.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              
              if (itemText === 'shop') {
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', !isExpanded);
                
                const success = triggerShopMegaMenu(this);
                
                if (success) {
                  setTimeout(() => {
                    const openDropdown = document.querySelector(
                      '.megamenu-desktop:not([style*="display: none"]), ' +
                      '.mega-menu:not([style*="display: none"]), ' +
                      '[x-show*="shop"]:not([style*="display: none"]), ' +
                      '.dropdown-content[x-show="true"]'
                    );
                    
                    if (openDropdown) {
                      const firstLink = openDropdown.querySelector('a, button');
                      if (firstLink) {
                        firstLink.focus();
                      }
                    }
                  }, 150);
                }
                return;
              }
              
              this.click();
              
              const isExpanded = this.getAttribute('aria-expanded') === 'true';
              this.setAttribute('aria-expanded', !isExpanded);
              
              if (!isExpanded) {
                setTimeout(() => {
                  let openDropdown = null;
                  
                  const submenu = this.nextElementSibling;
                  if (submenu && 
                      (submenu.classList.contains('dropdown-content') || 
                       submenu.querySelector('.dropdown-content'))) {
                    openDropdown = submenu;
                  }
                  
                  if (!openDropdown) {
                    openDropdown = document.querySelector(
                      '.dropdown-content[x-show="true"], [x-show]:not([style*="display: none"])'
                    );
                  }
                  
                  if (!openDropdown && itemText === 'shop') {
                    openDropdown = document.querySelector(
                      '[x-show*="shop"]:not([style*="display: none"]), .mega-menu:not([style*="display: none"])'
                    );
                  }
                  
                  if (openDropdown) {
                    const firstLink = openDropdown.querySelector('a, button');
                    if (firstLink) {
                      firstLink.focus();
                    }
                  }
                }, 150);
              }
            }
          });
        } else if (item.tagName === 'BUTTON') {
          item.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
        } else if (item.tagName === 'A') {
          item.addEventListener('keydown', function(e) {
            if (e.key === ' ') {
              e.preventDefault();
              if (this.getAttribute('href')) {
                window.location.href = this.getAttribute('href');
              }
            }
          });
        }
      });
    };
    
    const desktopNavButtons = document.querySelectorAll('.level-1-link, .nav-item a, .nav-item button, nav a, .header a, button.level-1-link');
    processMenuItems(desktopNavButtons);
    
    const mobileNavButtons = document.querySelectorAll('.mobile-menu-links .level-1-link, .mobile-menu a, .mobile-nav a');
    processMenuItems(mobileNavButtons);

    const alpineDropdowns = document.querySelectorAll('[x-data], [x-show]');
    alpineDropdowns.forEach(dropdown => {
      const triggers = document.querySelectorAll('[x-on\\:click], [\\@click]');
      processMenuItems(triggers);
    });

    const shopItems = document.querySelectorAll(
      '.level-1-link[href*="shop"], ' + 
      '.level-1-link[href*="collection"], ' + 
      'a:contains("Shop"), ' + 
      'button:contains("Shop"), ' +
      'button.level-1-link:contains("Shop"), ' +
      'a.desktop-button:contains("Shop")'
    );
    
    shopItems.forEach(shopItem => {
      if (!shopItem.hasAttribute('data-shop-enhanced')) {
        shopItem.setAttribute('data-shop-enhanced', 'true');
        shopItem.setAttribute('aria-haspopup', 'true');
        shopItem.setAttribute('aria-expanded', 'false');
        
        shopItem.addEventListener('keydown', function(e) {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            
            const success = triggerShopMegaMenu(this);
            
            if (success) {
              setTimeout(() => {
                const openDropdown = document.querySelector(
                  '.megamenu-desktop:not([style*="display: none"]), ' +
                  '.mega-menu:not([style*="display: none"]), ' +
                  '[x-show*="shop"]:not([style*="display: none"]), ' +
                  '.dropdown-content[x-show="true"]'
                );
                
                if (openDropdown) {
                  const firstLink = openDropdown.querySelector('a, button');
                  if (firstLink) {
                    firstLink.focus();
                  }
                }
              }, 150);
            }
          }
        });
      }
    });

    const mainNavItems = document.querySelectorAll('#menu-desktop-global .level-1-link, .flex.h-full.justify-center.space-x-8 .level-1-link, header .level-1-link, .nav-links .level-1-link, nav > ul > li > a');
    mainNavItems.forEach((item, index) => {
      if (item.hasAttribute('data-main-nav-enhanced')) return;
      
      item.setAttribute('data-main-nav-enhanced', 'true');
      
      const itemId = item.textContent.trim().toLowerCase();
      let dropdown = null;
      
      document.querySelectorAll('[x-show]').forEach(el => {
        const showAttr = el.getAttribute('x-show');
        if (showAttr && showAttr.includes(`'${itemId}'`) || showAttr.includes(`"${itemId}"`)) {
          dropdown = el;
        }
      });
      
      if (dropdown || hasDropdown(item) || itemId === 'shop') {
        item.setAttribute('aria-haspopup', 'true');
        item.setAttribute('aria-expanded', 'false');
        
        item.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            
            if (itemId === 'shop') {
              const expanded = this.getAttribute('aria-expanded') === 'true';
              this.setAttribute('aria-expanded', !expanded);
              
              const success = triggerShopMegaMenu(this);
              
              if (success) {
                setTimeout(() => {
                  const openDropdown = document.querySelector(
                    '.megamenu-desktop:not([style*="display: none"]), ' +
                    '.mega-menu:not([style*="display: none"]), ' +
                    '[x-show*="shop"]:not([style*="display: none"]), ' +
                    '.dropdown-content[x-show="true"]'
                  );
                  
                  if (openDropdown) {
                    const firstLink = openDropdown.querySelector('a, button');
                    if (firstLink) {
                      firstLink.focus();
                    }
                  }
                }, 150);
              }
              return;
            }
            
            this.click();
            
            const expanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !expanded);
            
            if (window.Alpine) {
              const store = getAlpineStoreData();
              if (store) {
                if (itemId === 'shop') {
                  if (store.activeTab !== undefined) {
                    store.activeTab = 'shop';
                  } else if (store.currentTab !== undefined) {
                    store.currentTab = 'shop';
                  } else if (store.active !== undefined) {
                    store.active = 'shop';
                  }
                } else {
                  const tabProps = ['activeTab', 'active', 'currentTab'];
                  tabProps.forEach(prop => {
                    if (store[prop] !== undefined) {
                      store[prop] = itemId;
                    }
                  });
                }
                
                setTimeout(() => {
                  let openDropdown = document.querySelector(
                    `.dropdown-content[x-show="true"], 
                     [x-show]:not([style*="display: none"]), 
                     [x-show*="${itemId}"]:not([style*="display: none"]),
                     .mega-menu:not([style*="display: none"])`
                  );
                  
                  if (openDropdown) {
                    const firstLink = openDropdown.querySelector('a, button');
                    if (firstLink) {
                      firstLink.focus();
                    }
                  }
                }, 150);
              }
            }
          }
        });
      } else {  
        item.addEventListener('keydown', function(e) {
          if (e.key === ' ') {
            e.preventDefault();
            if (this.tagName === 'A' && this.getAttribute('href')) {
              window.location.href = this.getAttribute('href');
            } else {
              this.click();
            }
          }
        });
      }
    });
  }

  function enhanceHeroSlider() {
    const heroSliders = document.querySelectorAll('.hero-slider, .splide, .slider, [data-splide]');
    
    heroSliders.forEach(slider => {
      const sliderControls = slider.querySelectorAll('.splide__arrow, .splide__pagination__page, .slider-controls button, .slider-navigation, .slider-pagination button');
      sliderControls.forEach(control => {
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', control.classList.contains('splide__arrow--prev') ? 'Previous slide' : 
                                           control.classList.contains('splide__arrow--next') ? 'Next slide' : 
                                           'Go to slide');
      });
      
      const slides = slider.querySelectorAll('.splide__slide, .slide, .slider-slide');
      slides.forEach(slide => {
        const slideLinks = slide.querySelectorAll('a[href], .cta, .button, .btn');
        const slideButtons = slide.querySelectorAll('button');
        
        if (slide.getAttribute('aria-hidden') === 'true') {
          slide.setAttribute('aria-hidden', 'false');
        }
        
        slideLinks.forEach(link => {
          if (!link.hasAttribute('tabindex')) {
            link.setAttribute('tabindex', '0');
          }
          
          let parent = link.parentElement;
          while (parent && parent !== slide) {
            if (parent.getAttribute('aria-hidden') === 'true') {
              parent.setAttribute('aria-hidden', 'false');
            }
            parent = parent.parentElement;
          }
          
          const insetSpan = link.querySelector('span.inset-0, span.absolute, .inset');
          if (insetSpan) {
            const visibleButton = document.createElement('span');
            visibleButton.classList.add('sr-only');
            visibleButton.textContent = link.getAttribute('aria-label') || 'View details';
            link.appendChild(visibleButton);
            
            link.addEventListener('focus', () => {
              link.style.outline = '3px solid #5F9353';
              link.style.outlineOffset = '4px';
              link.style.borderRadius = '4px';
              link.style.position = 'relative';
              link.style.zIndex = '30';
            });
            
            link.addEventListener('blur', () => {
              link.style.outline = '';
              link.style.outlineOffset = '';
              link.style.borderRadius = '';
              link.style.position = '';
              link.style.zIndex = '';
            });
          }
          
          link.addEventListener('keydown', function(e) {
            if (e.key === ' ') {
              e.preventDefault();
              if (this.getAttribute('href')) {
                window.location.href = this.getAttribute('href');
              } else {
                this.click();
              }
            }
          });
        });
        
        slideButtons.forEach(button => {
          if (!button.hasAttribute('tabindex')) {
            button.setAttribute('tabindex', '0');
          }
          
          button.addEventListener('keydown', function(e) {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              this.click();
            }
          });
        });
      });
    });
  }

  // Call enhancement functions
  enhanceNavigation();
  enhanceHeroSlider();
}); 